import { collection, doc, getDoc, getDocs, query, setDoc, Timestamp, where } from "firebase/firestore";
import { db } from "../firebase";
import Widgets, { Widget } from "../models/Widgets";

const getWidgets = async (plan_id: string): Promise<Widgets> => {
    const colRef = collection(db, "widgets");
    const q = doc(colRef, plan_id);

    const snapshot = await getDoc(q);
    if (snapshot.exists()) {
        const data = snapshot.data();
        const widgets: Widgets = {
            uid: snapshot.id,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
            widgets: data.widgets,
        }
        return widgets;
    }
    await createWidgets(plan_id);
    const widgets = await getWidgets(plan_id);
    return widgets;
}

const createWidgets = async (plan_id: string) => {
    const colRef = collection(db, "widgets");
    const widgets: Partial<Widgets> = {
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        widgets: [],
    }
    const docRef = doc(colRef, plan_id);
    await setDoc(docRef, widgets);
}

const setWidgets = async (plan_id: string, widgets: Widget[]) => {
    const colRef = collection(db, "widgets")
    const docRef = doc(colRef, plan_id);
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) {
        throw new Error("No widgets found for the given plan_id.");
    }
    const data = snapshot.data();
    data.widgets = widgets;
    await setDoc(docRef, data);
}

const WidgetsController = {
    getWidgets,
    createWidgets,
    setWidgets,
}

export default WidgetsController;